/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useMemo} from 'react'
import {FormattedNumber, IntlProvider} from 'react-intl'
import {useQueryRequest} from '../core/QueryRequestProvider'
import { useGetAttendanceLog } from '../core/_query'
import moment from 'moment'

type Props = {
  className: string
}

const TopAttendance: React.FC<Props> = ({className}) => {
  const {state} = useQueryRequest()
  const {data: topTreatmentData} = useGetAttendanceLog({...state, set_is_job_therapist: false})

  const data = useMemo(() => {
    return topTreatmentData?.response?.data || []
  }, [topTreatmentData])

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3'>Recent Check-In</span>
        </h3>
        {/* <div className='card-toolbar' data-kt-buttons='true'>
          <a
            className='btn btn-sm btn-color-muted btn-active btn-active-primary active px-4 me-1'
            id='kt_charts_widget_2_year_btn'
          >
            Transaction
          </a>

          <a
            className='btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1'
            id='kt_charts_widget_2_month_btn'
          >
            Sales
          </a>
        </div> */}
      </div>
      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='min-w-30px'>No</th>
                <th className='min-w-200px'>Check In Attendance </th>
                <th className='min-w-100px'>Employee</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {data !== undefined ? (
                data?.map((treatment, index) => (
                  <tr key={index}>
                    <td>
                      <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                        {index + 1}
                      </a>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start flex-column'>
                          <a href='#' className='text-dark fw-bold text-hover-primary fs-6'>
                            {moment(treatment.check_in_time).format('DD-MMM-yyyy HH:mm:ss')}
                          </a>
                        </div>
                      </div>
                    </td>
                    <td>
                      <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                        {treatment.attendance_name}
                      </a>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4}>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                      No matching records found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {TopAttendance}
